import BpkImage, {
  withLazyLoading,
} from '@skyscanner-internal/backpack-web/bpk-component-image';
import BpkPanel from '@skyscanner-internal/backpack-web/bpk-component-panel';
import BpkText, {
  TEXT_COLORS,
  TEXT_STYLES,
} from '@skyscanner-internal/backpack-web/bpk-component-text';

import CardRail from '../CardRail';
import { useMBDContext } from '../common/MBD/useMBDContext';

import type { EditorialCardRailProps } from '@skyscanner-internal/landing-pages-shared-types/types-shared/EditorialCardRailProps';

import STYLES from './EditorialCardRail.module.scss';

const documentIfExists = typeof window !== 'undefined' ? document : null;
const LazyLoadedImage = withLazyLoading(BpkImage, documentIfExists);
const IMG_WIDTH = 392;
const IMG_HEIGHT = 261;

const EditorialCardRail = ({
  cards,
  subtitle = undefined,
  title,
}: EditorialCardRailProps) => {
  const { buildMBDParam, rawComponentName } = useMBDContext();

  if (!cards.length) {
    return null;
  }

  return (
    <div
      className={STYLES.EditorialCardRail}
      data-tracking-element-id={rawComponentName}
      data-tracking-common-params={buildMBDParam(rawComponentName)}
    >
      <CardRail title={title} subtitle={subtitle}>
        {cards.map((card, index) => {
          const itemTrackingName = `${rawComponentName}_item`;

          return (
            <div
              key={`${card.title}-${card.body}`}
              className={STYLES.EditorialCardRail__cardWrapper}
              data-tracking-element-id={`${itemTrackingName}_${index}`}
              data-tracking-common-params={buildMBDParam(itemTrackingName)}
            >
              <BpkPanel
                padded={false}
                keyline={false}
                className={STYLES.EditorialCardRail__card}
              >
                <div className={STYLES.EditorialCardRail__image}>
                  <LazyLoadedImage
                    aspectRatio={IMG_WIDTH / IMG_HEIGHT}
                    altText={card.imageAltText}
                    src={card.imageSrc}
                  />
                </div>
                <div className={STYLES.EditorialCardRail__body}>
                  <BpkText tagName="h3" textStyle={TEXT_STYLES.heading4}>
                    {card.title}
                  </BpkText>
                  <BpkText
                    tagName="p"
                    textStyle={TEXT_STYLES.bodyDefault}
                    color={TEXT_COLORS.textSecondary}
                  >
                    {card.body}
                  </BpkText>
                </div>
              </BpkPanel>
            </div>
          );
        })}
      </CardRail>
    </div>
  );
};

export default EditorialCardRail;
